import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SurveyForm } from '../../../../../components/common/survey/form/SurveyForm';
import { SurveyInputHeader } from '../../../../../components/common/survey/inputs/SurveyInputHeader';
import { SurveyTextInput } from '../../../../../components/common/survey/inputs/SurveyTextInput';
import { useAppDispatch } from '../../../../../hooks/store/useStore';
import { userJoinSlice } from '../../../../../store/userJoinSlice';
import { JoinProcessPageWrapper } from '../JoinProcessPageWrapper';

export const JoinProcessJobDetailPage = () => {
  const navigate = useNavigate();
  const [jobDetail, setJobDetail] = useState<string>();

  const dispatch = useAppDispatch();
  const userJoinActions = userJoinSlice.actions;

  return (
    <JoinProcessPageWrapper
      headerTitle={'조금만 더 알려주세요\n어떤일을 하시나요?'}
      canConfirm={jobDetail !== undefined}
      confirmHandler={() => {
        dispatch(userJoinActions.changeJobEtc(jobDetail!));
        navigate('/join-process/reason', { replace: true });
      }}
    >
      <SurveyForm>
        <SurveyInputHeader inputTitle={'직업 입력'} isRequired />

        <SurveyTextInput
          inputValue={jobDetail}
          placeholder={'예) 회사원, 목수 등'}
          onChange={(value: string | undefined) => setJobDetail(value)}
        />
      </SurveyForm>
    </JoinProcessPageWrapper>
  );
};
